import { featureFlags } from "./flags";

export { featureFlags };

export function getFeatureFlag(flagName) {
  return featureFlags[flagName];
}

export function isFeatureEnabled(flagName) {
  return getFeatureFlag(flagName) === true;
}
